import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_report_inputs_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { reportName: string, inputs?: { name: string, value?: string }[], $top?: number, $skip?: number }): Promise<{ result?: { name?: string, value?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.reportName)) {
      missingRequiredInParams.push('\'reportName\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_report_inputs_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { reportName?: string, inputs?: { name: string, value?: string }[], $keys: string[] }): Promise<{ result?: { name?: string, value?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_report_inputs_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      reportName: string, inputs?: { name: string, value?: string }[]    }) {
        if(isNil(inParams.reportName)) {
          return true; 
        }
      return false;
    }
}
